import { stripTags } from 'underscore.string';
import { pathPrefixMap } from '@data/navigation';
import parseTitle from './parseTitle';

export const isLinkInternal = (link) => {
  if (link.charAt(0) === '/') {
    return true;
  }

  if (link.split('/')[2] === 'new.smm.org') {
    return true;
  }

  return false;
};

export const parseInternalLink = (link) => {
  if (link.charAt(0) === '/') {
    return link;
  }

  return link.split('.org')[1];
};

const setParentTitle = (parent) => {
  const parentTitle = parent?.titleBreadcrumb || parent?.titleDisplay;
  const title = parentTitle || 'Title unknown';

  return title;
};

export const arrangedParentData = (data) => {
  const result = [];
  let currentObject = data;

  function setResultRecursive() {
    const { parentPage } = currentObject;

    if (!parentPage) {
      result.unshift({ title: 'Home', link: '/' });
      return null;
    }

    const resultItem = {
      title: setParentTitle(parentPage),
      // eslint-disable-next-line no-underscore-dangle
      link: pathPrefixMap[parentPage.__typename] ? `${pathPrefixMap[parentPage.__typename]}${parentPage.slug}` : `/${parentPage.slug}`,
    };

    result.unshift(resultItem);
    currentObject = parentPage;

    return setResultRecursive();
  }

  setResultRecursive();
  result.push({ title: setParentTitle(data) });

  return result;
};

export const getHeadProps = (root) => ({
  pageTitle: parseTitle(stripTags(root.titleSeo || root.titleDisplay)),
  pageDescription: root?.descriptionSeo,
  pageKeywords: root?.keywordsSeo,
  pageImgUrl: root.banner && `https:${root.banner.file.url}`,
  pageAltText: root?.banner?.description,
});

export const adjustStringLength = (str, length) => {
  const splitedString = str.split(' ');
  const isMultipleWord = splitedString.length > 1;
  let result = '';

  if (!isMultipleWord) {
    return `${str.trim().substr(0, length).trim()}`;
  }

  splitedString.every((subString) => {
    const tempString = `${result}${subString}`;
    if (tempString.length > length) {
      result = `${result.trim().substr(0, length).trim()}...`;
      return false;
    }

    result += `${subString} `;
    return true;
  });

  return result;
};
